var actions, initialState;

actions = require('../actions/user');

initialState = {
  isFetching: false,
  didInvalidate: false,
  data: {},
  error: null,
  gameId: null
};

module.exports = function(state, action) {
  if (state == null) {
    state = initialState;
  }
  switch (action.type) {
    case actions.INVALIDATE_USER:
      return Object.assign({}, state, {
        didInvalidate: true
      });
    case actions.LOGIN_USER:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.SESSION_LOGIN:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.RECEIVE_USER:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        error: null,
        data: action.data,
        lastUpdated: action.receivedAt
      });
    case actions.JOINED_GAME:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        gameId: action.gameId,
        lastUpdated: action.receivedAt
      });
    case actions.LOGOUT:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        lastUpdated: action.receivedAt
      });
    case actions.LOGGED_OUT:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        data: {},
        gameId: null,
        lastUpdated: action.receivedAt
      });
    case actions.FAILED_LOGIN:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        data: {},
        gameId: null,
        error: action.errorMessage
      });
    case actions.DISMISS_ERROR:
      return Object.assign({}, state, {
        error: null
      });
    default:
      return state;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/reducers/user.coffee
 ** module id = 283
 ** module chunks = 0
 **/